<template>
    <div
        v-if="errorStore.errors.length"
        class="cr:fixed cr:inset-0 cr:z-[1000] cr:flex cr:flex-col cr:items-center cr:pointer-events-none cr:top-[5rem]"
    >
        <div
            v-for="error in errorStore.errors"
            :key="error.id"
            class="cr:w-full cr:max-w-md cr:bg-red-500 cr:text-white cr:rounded-lg cr:shadow-lg cr:pointer-events-auto cr:mb-4"
        >
            <div class="cr:p-4 cr:flex cr:justify-between cr:items-center">
                <p class="cr:text-sm cr:font-medium">
                    {{ error.error }}
                </p>
                <button
                    @click="errorStore.clearError(error.id)"
                    class="cr:ml-4 cr:text-white cr:hover:text-red-200 cr:cursor-pointer"
                >
                    X
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import {useErrorStore} from "@/stores/error.ts";

const errorStore = useErrorStore();

</script>